<table [ngClass]="cssClass(state?.dataSeverity)">
	<tr>
		<td rowspan="2">{{label}}</td>
		<td><bi name="check" [ngClass]="state?.resolved ? 'resolved' : ''"></bi></td>
	</tr>
	<tr><td><bi name="chat-left-text" [ngClass]="cssClass(state?.commentsSeverity)"></bi></td></tr>
</table>
